module.exports = __webpack_public_path__ + "assets/img/yyCare_bn_1.1e50f204.png";